export interface PermissionInterface {
    screen_name : string;
    permissions : string[];
}

export const mapPermission = (data:any): PermissionInterface => {
    if(!data){
        throw new Error('Invalied PermissionInterface type')
    }
    const SowSubSections: PermissionInterface = {
        screen_name: data.screen_name,
        permissions: Array.isArray(data.permissions) ? data.permissions : [],
        
    }

    return SowSubSections;

}

export const mapPermissions = (data: any[]): PermissionInterface[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid PermissionInterface data');
    }
  
    return data.map(mapPermission);
};